export default __webpack_public_path__ + "static/media/15.9a56580e.png";